import React from 'react';

const Footer = () => {
  return (
    <footer style={{background: '#1a1d23', borderTop: '1px solid #2d3139', position: 'relative', zIndex: 20}}>
      <div className="container">
        <div className="d-flex flex-wrap justify-content-between align-items-center py-3">
          <div className="text-start">
            <p className="mb-0" style={{color: '#9ca3af', fontSize: '0.85rem'}}>
              &copy; {new Date().getFullYear()} <span style={{color: '#e5e7eb'}}>Infocareer Pvt Ltd.</span> All Rights Reserved.
            </p>
            <p className="mb-0" style={{color: '#6b7280', fontSize: '0.75rem'}}>
              Designed By <a href="https://www.legenditsolutions.com" target="_blank" rel="noopener noreferrer" style={{color: '#6b7280', textDecoration: 'none'}}>Legend IT Solutions</a>
            </p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <a href="https://www.linkedin.com/in/infocareer-mentoring-55627a280/" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', fontSize: '1.1rem', transition: 'color 0.2s'}} className="footer-social-link">
              <i className="bi bi-linkedin"></i>
            </a>
            <a href="https://www.facebook.com/Mentoring.infocareerindia/" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', fontSize: '1.1rem', transition: 'color 0.2s'}} className="footer-social-link">
              <i className="bi bi-facebook"></i>
            </a>
            <a href="https://www.instagram.com/infocareer_mentoring/" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', fontSize: '1.1rem', transition: 'color 0.2s'}} className="footer-social-link">
              <i className="bi bi-instagram"></i>
            </a>
            <a href="https://www.youtube.com/@ICMentoring_/" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', fontSize: '1.1rem', transition: 'color 0.2s'}} className="footer-social-link">
              <i className="bi bi-youtube"></i>
            </a>
          </div>
          <div className="d-flex align-items-center gap-2" style={{fontSize: '0.8rem'}}>
            <a href="https://infocareerindia.com/wp-content/uploads/2023/01/Infocareer-Privacy-Policy.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', textDecoration: 'none'}}>Privacy Policy</a>
            <span style={{color: '#4b5563'}}>|</span>
            <a href="https://infocareerindia.com/wp-content/uploads/2023/01/Infocareer-Terms-of-Use.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', textDecoration: 'none'}}>Terms of Use</a>
            <span style={{color: '#4b5563'}}>|</span>
            <a href="https://www.infocareerindia.com/cookie-policy/" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', textDecoration: 'none'}}>Cookie Policy</a>
            <span style={{color: '#4b5563'}}>|</span>
            <a href="https://www.infocareerindia.com/cancellation/" target="_blank" rel="noopener noreferrer" style={{color: '#9ca3af', textDecoration: 'none'}}>Cancellation Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
